import React, { useImperativeHandle } from "react";
import {
  FilterFilterValueFormInterface,
  FilterFilterValueInterface,
} from "../../../../../../interfaces/FilterInterface";
import { Checkbox } from "@mui/material";
import { FormStateFilterForm } from "./FilterFormComponent";

interface State {
  filterValue: FilterFilterValueInterface;
  setValues: Function;
}

const FilterFormVisibleComponent = React.memo(
  React.forwardRef(({ filterValue, setValues }: State, ref) => {
    const [checked, setChecked] = React.useState(filterValue.show);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      setValues((x: FormStateFilterForm) => {
        const thisFilterValue = x.filterValues.value.find(
          (y: FilterFilterValueFormInterface) => y.refVisible === ref
        );
        thisFilterValue.show = event.target.checked;
        return { ...x };
      });
      setChecked(event.target.checked);
    };

    useImperativeHandle(ref, () => ({
      getValue() {
        return checked;
      },
    }));

    return <Checkbox checked={checked} onChange={handleChange} />;
  })
);

export default FilterFormVisibleComponent;
